export function stringToRgba(str: string, alpha = 1): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  let rgb = [0, 0, 0];
  for (let i = 0; i < rgb.length; i++) {
    rgb[i] = (hash >> (i * 8)) & 255;
  }
  return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
}
